var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-full"
  }, [_c('div', {
    staticClass: "md:px-15",
    on: {
      "keydown": _vm.onKeyDown,
      "keyup": _vm.onKeyUp
    }
  }, [_c('search-bar', {
    attrs: {
      "name": "searchBeneficiary",
      "libelle": "",
      "value": _vm.searchBeneficiary,
      "placeholder": "Rechercher un bénéficiaire",
      "big": false
    },
    on: {
      "input": function (newValue) {
        _vm.searchBeneficiary = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w-full space-y-5 mt-10"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2",
    class: [_vm.isLoading && 'justify-center']
  }, [_vm.isLoading ? _c('div', {
    staticClass: "animate-spin w-5 h-5 border-t border-b rounded-full border-gray-900"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isLoading,
      expression: "!isLoading"
    }],
    staticClass: "flex flex-col items-left"
  }, [_c('checkbox-indigo', {
    staticClass: "ml-1/12 md:ml-15",
    attrs: {
      "name": 'selectAllBeneficiaries',
      "libelle": 'Sélectionner tous les ' + _vm.totalNbBeneficiaries + ' bénéficiaires',
      "value": _vm.filter.length == _vm.totalNbBeneficiaries
    },
    on: {
      "input": function ($event) {
        return _vm.selectAllBeneficiaries();
      }
    }
  }), _vm._v(" "), _vm._l(_vm.groups, function (group) {
    return _c('div', {
      key: group.id,
      staticClass: "flex flex-row items-center gap-3"
    }, [_c('checkbox-indigo', {
      staticClass: "ml-1/12 md:ml-15",
      attrs: {
        "name": 'selectGroup' + group.id,
        "libelle": `Sélectionner le groupe ${group.name} (${group.users.length} bénéficiaires)`,
        "value": _vm.isGroupSelected(group)
      },
      on: {
        "input": function ($event) {
          return _vm.selectUserGroup(group);
        }
      }
    }), _vm._v(" "), _c('ActionButton', {
      attrs: {
        "border-color": "border-transparent",
        "text-color": "text-gray-900",
        "bg-color": "bg-pink-300",
        "bg-color-square": "bg-white",
        "icon-color": "text-pink-600",
        "icon": "trash",
        "responsive": true,
        "libelle": "Supprimer ce groupe",
        "is-disabled": group.name === undefined || group.name === ''
      },
      on: {
        "clickAction": function ($event) {
          return _vm.deleteGroup(group);
        }
      }
    })], 1);
  })], 2)]), _vm._v(" "), _c('list-grid', {
    attrs: {
      "list-items": _vm.beneficiaries,
      "is-listdisplayed": _vm.beneficiaries != null && _vm.beneficiaries.length > 0
    },
    scopedSlots: _vm._u([_vm.beneficiaries ? {
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "hidden md:block md:pl-15 col-span-3"
        }, [_vm._v("\n          Sélectionner\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "md:hidden md:pl-15 col-span-3 text-center"
        }, [_vm._v("\n          Sél.\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-9 md:col-span-5"
        }, [_vm._v("\n          Bénéficiaires\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:block md:col-span-4"
        }, [_vm._v("\n          " + _vm._s(_vm.filter.length) + " bénéficiaire" + _vm._s(_vm.filter.length > 1 ? 's' : '') + "\n          sélectionné" + _vm._s(_vm.filter.length > 1 ? 's' : '') + "\n        ")])];
      },
      proxy: true
    } : null, {
      key: "errorCases",
      fn: function () {
        return [_vm.beneficiaries && _vm.beneficiaries.length === 0 ? _c('div', {
          staticClass: "flex flex-col justify-center items-center w-full my-8"
        }, [_c('div', {
          staticClass: "text-pink-600 text-center text-lg mb-8"
        }, [_vm._v("\n            Aucun bénéficiaire !\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "text-indigo-600 text-center text-base mb-8"
        }, [_vm._v("\n            Il n'y a aucun bénéficiaire trouvé\n          ")]), _vm._v(" "), _c('div', [_c('illustration', {
          attrs: {
            "name": "no_result"
          }
        })], 1)]) : _vm._e()];
      },
      proxy: true
    }, {
      key: "accordionDescription",
      fn: function (_ref) {
        var item = _ref.item,
          num = _ref.num;
        return [_c('div', {
          staticClass: "col-span-3 md:pl-15 cursor-pointer flex justify-center md:block md:justify-start",
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.selectBeneficiary(item);
            }
          }
        }, [_c('checkbox-indigo', {
          attrs: {
            "name": 'selectBeneficiary' + item.id,
            "value": _vm.filteredBeneficiariesIds.includes(item.id)
          },
          on: {
            "input": function ($event) {
              return _vm.selectBeneficiary(item);
            }
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "col-span-9 cursor-pointer",
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.selectBeneficiary(item);
            }
          }
        }, [_vm._v("\n          " + _vm._s(item.firstname) + " " + _vm._s(item.lastname) + "\n        ")])];
      }
    }], null, true)
  }), _vm._v(" "), _vm.beneficiaries.length > 0 ? _c('div', {
    staticClass: "w-full flex items-center justify-center"
  }, [_c('div', {
    staticClass: "w-full md:w-1/2 flex items-center justify-center space-x-5"
  }, [_c('div', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.getToPreviousPage.apply(null, arguments);
      }
    }
  }, [_c('icon', {
    staticClass: "p-2 w-8 h-8 rounded-full",
    class: {
      'bg-gray-600 text-white': _vm.selectedPage === 1,
      'bg-pink-600 text-white cursor-pointer transform hover:scale-110 duration-300': _vm.selectedPage !== 1
    },
    attrs: {
      "name": "chevron-left"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-wrap items-center justify-center w-full"
  }, _vm._l(_vm.pages, function (pageNumber) {
    return _c('div', {
      key: 'pageNumber' + pageNumber,
      staticClass: "p-3 w-8 h-8 rounded-full flex justify-center items-center cursor-pointer transform hover:scale-110 duration-300",
      class: {
        'bg-pink-600 text-white': pageNumber === _vm.selectedPage
      },
      on: {
        "click": function ($event) {
          _vm.selectedPage = pageNumber;
        }
      }
    }, [_vm._v("\n            " + _vm._s(pageNumber) + "\n          ")]);
  }), 0), _vm._v(" "), _c('div', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.getToNextPage.apply(null, arguments);
      }
    }
  }, [_c('icon', {
    staticClass: "p-2 w-8 h-8 rounded-full",
    class: {
      'bg-gray-600 text-white': _vm.selectedPage == _vm.lastPage,
      'bg-pink-600 text-white cursor-pointer transform hover:scale-110 duration-300': _vm.selectedPage != _vm.lastPage
    },
    attrs: {
      "name": "chevron-right"
    }
  })], 1)])]) : _vm._e()], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }